import values from 'lodash/values';
import invert from 'lodash/invert';
import snakeCase from 'lodash/snakeCase';

import LayoutCommon from "../../visComponents/layoutCommon";

import {LayoutType, LayoutAbbreviation} from "./constants";
import zIndexes from "./zIndex";

import Other from "./parts/other";
import NonVisualizerSubPart from "./subparts/nonVisualizerSubPart";
import DesignNavigationItem from "../../visComponents/designNavigationItem";
import Background from "./parts/background";
import {ShowerAccessories} from "./parts/showerAccessories";
import {Toilet} from "./parts/toilet";
// import {WindowParent} from "./parts/windowParent";
import Floor from "./parts/floor";
import Walls from "./parts/walls";
import {Shower} from "./parts/shower";
import {Vanity} from "./parts/vanity";
import {ShowerTubCombo} from "./parts/showerTubCombo";
import Globals from "./parts/globals";
import {Bathtub} from "./parts/bathtub";
import {AVAILABLE_VISUALIZER_TYPES, IS_BATHROOM_OLD_BV_SCENE} from "../../../config";

export class Layout extends LayoutCommon {

  /**
   * @type {int}
   */
  defaultType = LayoutType.Layout1;
  type = this.defaultType;
  scene = "1";
  visualizerType = AVAILABLE_VISUALIZER_TYPES.bvScene;
  localStorageKey = "bvSceneState";
  layersBinding = IS_BATHROOM_OLD_BV_SCENE ? "Bathroom" : "BathroomV5";
  layoutNames = LayoutAbbreviation;
  layoutTypes = LayoutType;
  zIndexes = zIndexes.layouts;

  constructor(props) {
    super(props);
    this.parts[Background.id]     = new Background();
    this.parts[Walls.id] = new Walls();
    this.parts[Vanity.id]         = new Vanity();
    this.parts[Shower.id]         = new Shower();
    this.parts[ShowerTubCombo.id] = new ShowerTubCombo();
    this.parts[ShowerAccessories.id] = new ShowerAccessories();
    this.parts[Bathtub.id]        = new Bathtub();
    this.parts[Toilet.id]         = new Toilet();
    this.parts[Floor.id]          = new Floor();
    // this.parts[WindowParent.id] = new WindowParent();
    // this.parts[Ceiling.id]        = new Ceiling();
    this.parts[Globals.id] = new Globals();
    this.parts[Other.id] = new Other();
    values(this.parts).forEach(part => part.layout = this);
  }

  fixFeatureMetaData(dbFeature) {
    dbFeature.metaData.RoomLayout = dbFeature.metaData.RoomLayout.map((mValue) => {
      Object.values(LayoutType).map(val => val + "").forEach(stringNum => {
        if (mValue === stringNum) {
          mValue = "Layout" + mValue
        }
      })
      return mValue
    })
    return dbFeature
  }

  getCurrentLayoutName(type = this.type) {
    return invert(LayoutType)[type];
  }

  getCurrentLayoutAbbreviation() {
    return LayoutAbbreviation[this.getCurrentLayoutName()]
  }

  addNonVisualizerSubPart(featureGroupName){
    const otherParent = this.parts[Other.id];
    const partId = snakeCase(featureGroupName);
    let relatedItem = otherParent.relatedItems.find(relatedItem => relatedItem.partId === partId);
    if (!relatedItem) {
      relatedItem = new NonVisualizerSubPart(true, partId, featureGroupName);
      relatedItem.getParent = () => otherParent;
      otherParent.relatedItems.push(relatedItem);
    }
    return new DesignNavigationItem(relatedItem.partName, relatedItem)
  }

  excludedIndexesFromHover = (layoutType) => {
    return [
      this.zIndexes[layoutType].Background.BackgroundBG,  // exclude Globals
      ...Object.keys(this.zIndexes[layoutType].Globals).map(key => this.zIndexes[layoutType].Globals[key])
    ]
  }

}
